import { z } from "zod";
import { t } from "@smeetz/i18n";
import { optionalString, requiredString } from "@smeetz/services-validation";

export interface UserInfoValues {
  firstName: string;
  lastName: string;
  languageId: string | number;
  languageCode: string;
}

/**
 * Zod schema for the user info form.
 *
 * @returns {z.ZodType<UserInfoValues>} schema validating first/last name and language.
 */
export function userInfoSchema() {
  return z.object({
    firstName: requiredString({ min: 2, max: 45 }),
    lastName: requiredString({ min: 2, max: 45 }),
    languageId: z
      .union([z.string(), z.number()])
      .refine(
        (value) => value !== "" && value !== null && value !== undefined,
        {
          error: () => t("validations.enter-value"),
        }
      ),
    languageCode: optionalString(),
  });
}
